

























import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { AppBrowserTarget, openUrl } from "@/shared/mobileHelper";

@Component
export default class Privacy extends Vue {
  readonly privacyPolicyUrl = "https://user.bendhsa.com/bend_financial_privacy_policy_20181009.pdf";

  open (url) {
    openUrl(url, AppBrowserTarget.system);
  }

}
